module.exports = __webpack_public_path__ + "img/yellow-sticker.fe8e2c3.gif";